import {StatusDTO} from "./statusDTO.interface";
import {BaseDTO} from "./_baseDTO.interface";

export interface MediumDTO extends BaseDTO {
}
